import { Box, Typography } from '@mui/material'
import { useEffect, useState } from 'react'
import { pallete } from '../../../theme'
import { TranslatableTypography } from '../widgets'

const style = {
  '&': {
    textAlign: 'center',
    padding: '10px',
    '& p': {
      display: 'inline-block'
    },
    '& p:first-child': {
      marginRight: '5px'
    },
    '& p:last-child': {
      color: pallete.headerColor
    },
    '& p.ended': {
      color: pallete.errorColorRGB
    }
  }
}

const secondsUntil = (ms) => Math.max(0, Math.floor((ms - Date.now()) / 1000))

const formatSeconds = (totalSeconds) => {
  const hours = Math.floor(totalSeconds / 3600)
  const minutes = Math.floor((totalSeconds % 3600) / 60)
  const seconds = totalSeconds % 60
  if (hours >= 72) return 'more than 3 days'
  return [hours, minutes, seconds].map((n) => String(n).padStart(2, '0')).join(':')
}

export const VotingCountdown = ({ deadlineMs, votingStartMs, votingNotStarted }) => {
  const targetMs = votingNotStarted ? votingStartMs : deadlineMs
  const [seconds, setSeconds] = useState(targetMs != null ? secondsUntil(targetMs) : 0)

  useEffect(() => {
    if (targetMs == null) return
    if (secondsUntil(targetMs) <= 0) return
    const timer = setInterval(() => {
      const remaining = secondsUntil(targetMs)
      setSeconds(remaining)
      if (remaining === 0) {
        clearInterval(timer)
        window.location.reload()
      }
    }, 1000)
    return () => clearInterval(timer)
  }, [targetMs])

  if (votingNotStarted) {
    if (!votingStartMs) return null
    return (
      <Box sx={style}>
        <TranslatableTypography text="Voting starts in:" />
        <Typography>{formatSeconds(seconds)}</Typography>
      </Box>
    )
  }

  if (!deadlineMs) return null

  if (seconds > 0) {
    return (
      <Box sx={style}>
        <TranslatableTypography text="Voting ends in:" />
        <Typography>{formatSeconds(seconds)}</Typography>
      </Box>
    )
  }

  return (
    <Box sx={style}>
      <TranslatableTypography text="Voting has ended" className="ended" />
    </Box>
  )
}
